import { render } from "./ExamView.vue?vue&type=template&id=a5de24a6&ts=true"
import script from "./ExamView.vue?vue&type=script&lang=ts"
export * from "./ExamView.vue?vue&type=script&lang=ts"

import "./ExamView.vue?vue&type=style&index=0&id=a5de24a6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__